/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
import router from '@/router/index';

const initialState = () => ({
  error: '',
  loading: false,
  business: {},
  members: [],
  projects: [],
  broles: [],
  bpermissions: [],
  add_member_error: '',
  projects_overview: [],
  is_loading_members: false
});

// State object
const state = initialState();
// Getter functions
const getters = {
  isLoading: (state) => state.loading,
  getBusiness: (state, getters, rootState) => {
    if (rootState.Auth.current_user && rootState.Auth.current_user.business) {
      return rootState.Ultra.businesses[rootState.Auth.current_user.business.id];
    } else {
      return {
        id: -1,
        projects: [],
        usersbusinesses: [],
        clients: []
      };
    }
  },
  getBusinessMembers: (state, getters, rootState, rootGetters) => {
    let members = [];
    rootGetters['Ultra/getUObjects']({ type: 'usersbusinesses', ids: rootGetters['Ultra/getUObject']({ type: 'businesses', id: getters.getBusiness.id }).usersbusinesses }).forEach((item) => {
      members.push({
        usersbusiness_id: item.id,
        id: item.user.id,
        image: item.user.image,
        first_name: item.user.first_name,
        last_name: item.user.last_name,
        email: item.user.email,
        phone_number: item.user.phone_number,
        brole: item.brole
      });
    });
    return members;
  },
  getBusinessProjects: (state, getters, rootState, rootGetters) => {
    return rootGetters['Ultra/getUObjects']({type: 'projects', ids: getters.getBusiness.projects});
  },
  getBusinessRoles: (state) => state.broles,
  getAddMemberError: (state) => state.add_member_error,
  getBusinessProject: (state) => (project_id) => {
    const index = state.projects.findIndex(function(item) {
      return item.id == project_id;
    });
    return state.projects[index];
  },
  hasBusinessPermission: (state) => (bpermission) => {
    let res = state.bpermissions.includes(bpermission);
    return res;
  },
  isLoadingMembers: (state) => state.is_loading_members
};
// Actions
const actions = {
  resetAddMemberError({commit}){
    commit('set_add_member_error', '');
  },
  requestBusiness({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'businesses/' + payload.id + '?show=showForBusiness',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        let business = resp.data.data;
        let members = business.users;
        let projects = business.projects;
        let broles = business.broles;
        delete business.users;
        delete business.projects;
        delete business.broles;
        commit('set_business', business);
        commit('set_members', members);
        commit('set_projects', projects);
        commit('set_broles', broles);
        resolve();
      })
      .catch(err => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestBusinessPermissions({commit, rootGetters}, payload){
    return new Promise((resolve, reject) => {
      if (rootGetters['Auth/getUserId'] === 0) {
        // wait a bit
        setTimeout(function () {
        }, 1500);
      }
      axios({
        url: 'users/' + rootGetters['Auth/getUserId'] + '/bpermissions/' + payload.id,
        method: 'GET',
        headers: {
          'cache-control': 'no-cache'
        }
      }).then(resp => {
        commit('set_bpermissions', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestAllBPermissions({commit, rootState}) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'businesses/0/broles/0/bpermissions?show=showWithEntitiesNormalized',
          method: 'GET'
        })
        .then(resp => {
          let payload = {
            url: [
              {allbpermissions: ''},
              {showWithEntitiesNormalized: ''}
            ],
            resp_data: {
              allbpermissions: resp.data.data.bpermissions
            }
          };
          commit('Ultra/create_u_objects', {rootState, payload}, { root: true });
          resolve();
        })
        .catch(err => {
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  addUsers({commit, dispatch}, payload){
    commit('set_loading_members', true);
    commit('set_add_member_error', '');
    axios({
      url: 'businesses/' + payload.business_id + '/addusers',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      // hacky way, because we don't get the user object back at the moment...
      dispatch('Ultra/requestUObject', {
        url: [
          { businesses: payload.business_id },
          { showWithEntitiesNormalized: '' }
        ],
        no_cache: true
      }, {root:true})
      .then(() => {
        commit('set_loading_members', false);
        }
      );
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_loading_members', false);
      let msg = err.response.data.error_msg;
      switch (msg) {
        case 'User has to be a Full User.':
        case 'User with given email not found.':
        case 'User is already in a business.':
          commit('set_add_member_error', msg);
          break;
        case 'The given payload was not valid.':
          commit('set_add_member_error', 'The given email hostname and domain are not registered with this Company.');
          break;
        default:
          commit('set_error', extractErrorDetails(err));
      }

    });
  },
  removeUsers({commit}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/removeusers',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      commit('Ultra/remove_u_object', {
        url: [
          {businesses: payload.business_id},
          {usersbusinesses: payload.usersbusiness_id}
        ]
      },
      {root: true});
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateInBusinessProjects({commit}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/bproletemplates/' + payload.bproletemplate_id + '/rollout',
      method: 'PUT',
      data: {}
    })
    .then(() => {
      console.log('done');
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateMemberBRole({commit, getters, rootState}, payload){
    if (payload.fuck_getters) {
      // ?!!?!?!?!?!
      console.log(getters);
    }
    axios({
      url: 'businesses/' + payload.business_id + '/changeuserbrole',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      commit('Ultra/update_u_object', {
        rootState: rootState,
        payload: {
          url: [
            {usersbusinesses: payload.usersbusiness_id}
          ],
          update: {
            brole: {
              name: rootState.Ultra.broles[payload.payload.users[0].brole_id].name,
              id: rootState.Ultra.broles[payload.payload.users[0].brole_id].id,
              description: rootState.Ultra.broles[payload.payload.users[0].brole_id].description,
              created: rootState.Ultra.broles[payload.payload.users[0].brole_id].created,
              updated: rootState.Ultra.broles[payload.payload.users[0].brole_id].updated
            }
          }
        }
      },
      {root: true});
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  requestBusinessProjectOverview({commit}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/projects',
      method: 'GET'
    })
    .then(res => {
      commit('business_projects_overview', res.data.data);
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  addProjects({commit, rootGetters}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/addprojects',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      for (let i = 0; i < payload.payload.projects.length; i++) {
        commit('add_project', rootGetters['Project/getOwnProject'](payload.payload.projects[i].id));
      }
      router.push({name: payload.nav_back?payload.nav_back:'CompanyManage'});
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  removeProjects({commit}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/removeprojects',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      for (let i = 0; i < payload.payload.projects.length; i++) {
        commit('remove_project', payload.payload.projects[i].id);
      }
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      commit('set_error', extractErrorDetails(err));
    });
  },
  joinProject({commit}, payload){
    axios({
      url: 'businesses/' + payload.business_id + '/joinproject',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      router.push({ name: 'Project', params: { project_id: payload.payload.project_id }});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  removeBPermission({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { businesses: payload.business_id }, // -3
          { broles: payload.brole_id }, // -2
          { bpermissions: payload.bpermission_id }, // -1
        ]
      };
      commit('Ultra/remove_u_object', ultra_payload, { root: true });
      axios({
        url: 'businesses/' + payload.business_id + '/broles/' + payload.brole_id + '/removepermission',
        method: 'PUT',
        data: {
          bpermission: payload.bpermission_id,
        },
      })
      .then( () => {
        resolve();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        let ultra_payload = {
          url: [
            { businesses: payload.business_id }, // -4
            { broles: payload.brole_id }, // -3
            { bpermissions: payload.bpermission_id }, // -2
            { random: '' } // -1
          ],
          resp_data: { bpermissions: [{ id: payload.bpermission_id }] }
        };
        commit('Ultra/add_u_object', ultra_payload, { root: true });
        reject();
      });
    });

  },
  addBPermission({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { businesses: payload.business_id }, // -4
          { broles: payload.brole_id }, // -3
          { bpermissions: payload.bpermission_id }, // -2
          { random: '' } // -1
        ],
        resp_data: { bpermissions: [{ id: payload.bpermission_id }] }
      };
      commit('Ultra/add_u_object', ultra_payload, { root: true });
      axios({
        url: 'businesses/' + payload.business_id + '/broles/' + payload.brole_id + '/addpermission',
        method: 'PUT',
        data: {
          bpermission: payload.bpermission_id,
        },
      })
      .then( () => {
        resolve();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        let ultra_payload = {
          url: [
            { businesses: payload.business_id }, // -3
            { broles: payload.brole_id }, // -2
            { bpermissions: payload.bpermission_id }, // -1
          ]
        };
        commit('Ultra/remove_u_object', ultra_payload, { root: true });
        reject();
      });
    });

  },
  removePPermissionToTemplate({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { businesses: payload.business_id }, // -3
          { bproletemplates: payload.bproletemplate_id }, // -2
          { ppermissions: payload.ppermission_id }, // -1
        ]
      };
      commit('Ultra/remove_u_object', ultra_payload, { root: true });
      axios({
        url: 'businesses/' + payload.business_id + '/bproletemplates/' + payload.bproletemplate_id,
        method: 'PUT',
        data: {
          ['remove#ppermissions']: [payload.ppermission_id],
        },
      })
      .then( () => {
        resolve();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        let ultra_payload = {
          url: [
            { businesses: payload.business_id }, // -4
            { bproletemplates: payload.bproletemplates_id }, // -3
            { ppermissions: payload.ppermission_id }, // -2
            { random: '' } // -1
          ],
          resp_data: { ppermissions: [{ id: payload.ppermission_id }] }
        };
        commit('Ultra/add_u_object', ultra_payload, { root: true });
        reject();
      });
    });

  },
  addPPermissionToTemplate({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { businesses: payload.business_id }, // -4
          { bproletemplates: payload.bproletemplate_id }, // -3
          { ppermissions: payload.ppermission_id }, // -2
          { random: '' } // -1
        ],
        resp_data: { ppermissions: [{ id: payload.ppermission_id }] }
      };
      commit('Ultra/add_u_object', ultra_payload, { root: true });
      axios({
        url: 'businesses/' + payload.business_id + '/bproletemplates/' + payload.bproletemplate_id,
        method: 'PUT',
        data: {
          ['add#ppermissions']: [payload.ppermission_id],
        },
      })
      .then( () => {
        resolve();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        let ultra_payload = {
          url: [
            { businesses: payload.business_id }, // -3
            { bproletemplates: payload.bproletemplate_id }, // -2
            { ppermissions: payload.ppermission_id }, // -1
          ]
        };
        commit('Ultra/remove_u_object', ultra_payload, { root: true });
        reject();
      });
    });

  },
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err) {
    state.error = err;
  },
  set_business(state, business) {
    state.business = business;
  },
  set_members(state, members){
    state.members = [...members];
  },
  remove_member(state, id){
    const index = state.members.findIndex(function(item) {
      return item.id == id;
    });
    state.members = [
      ...state.members.slice(0, index),
      ...state.members.slice(index + 1)
    ];
  },
  set_projects(state, projects){
    state.projects = [...projects];
  },
  set_broles(state, broles){
    state.broles = [...broles];
  },
  set_bpermissions(state, bpermissions){
    state.bpermissions = [...bpermissions];
  },
  set_add_member_error(state, msg){
    state.add_member_error = msg;
  },
  add_project(state, project){
    state.projects.push(project);
  },
  business_projects_overview(state, overivew){
    state.projects_overview = [...overivew];
  },
  remove_project(state, id){
    const index = state.projects.findIndex(function(item) {
      return item.id == id;
    });
    state.projects = [
      ...state.projects.slice(0, index),
      ...state.projects.slice(index + 1)
    ];
  },
  set_loading_members(state, payload) {
    state.is_loading_members = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
